import React, { useState } from "react";
import BrandHeader from "@/components/BrandHeader";
import SpinnerButton from "@/components/SpinnerButton";
import { teamApi } from "@/lib/api";
import { usePageMeta } from "@/lib/usePageMeta";

export default function TeamLogin() {
  usePageMeta({ title: "Team Sign In \u2014 SCW Contact Hub", robots: "noindex, nofollow" });
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setMsg("");
    try {
      const res = await teamApi.login(email);
      setMsg(res.data.message);
    } catch {
      setMsg("If your email is registered, you'll receive a sign-in link shortly.");
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#FFFFFF", display: "flex", flexDirection: "column" }}>
      <BrandHeader label={"Contact Hub \u00b7 Team"} homeHref="/team/login" testIdPrefix="team-login-header" />
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 28px" }}>
        <form onSubmit={submit} style={{ width: "100%", maxWidth: 380 }} data-testid="team-login-form">
          <p className="scw-eyebrow" style={{ marginBottom: 8 }}>Sign in</p>
          <h1 style={{ fontSize: 28, margin: "0 0 28px 0" }}>Team access</h1>
          <p style={{ fontSize: 14, color: "var(--scw-muted)", marginBottom: 24 }}>Enter your email and we'll send you a sign-in link.</p>
          <div style={{ marginBottom: 22 }}>
            <label className="scw-label">Email</label>
            <input className="scw-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="team-login-email" />
          </div>
          <SpinnerButton loading={loading} dataTestId="team-login-submit">Send sign-in link</SpinnerButton>
          {msg && <p style={{ marginTop: 16, color: "#5C5C5C", fontSize: 13 }} data-testid="team-login-msg">{msg}</p>}
        </form>
      </div>
    </div>
  );
}
